<script lang="ts" setup>
import Content from "./components/Content.vue"
import More from "./components/More.vue"
import type { Breadcrumb, CategoryList } from "@/utils/types"

const { t } = useI18n()
const route = useRoute()
const { contest } = useApi()
const id = route.params.id as string
const { data, pending, execute } = await contest.getContest(id)
const contestResult = computed(() => data.value?.data)

const tags = computed(() => contestResult.value?.info.tags.map((item) => {
  return {
    title: item.name,
    link: `/competition?tags[]=${item.name}`,
  } as CategoryList
}))


const bread = computed<Breadcrumb[]>(() => {
  return [
    {
      title: t('menu.competition'),
    },
  ]
})
</script>

<template>
  <div class="bread">
    <Breadcrumb :data="bread" :border="false" />
    <div class="bread__bottom wrap">
      <div class="bread__bottom__inner">
        <Category :data="tags" />
      </div>
    </div>
  </div>
  <section class="content">
    <div class="wrap">
      <div class="content__inner">
        <Content :data="contestResult?.info" />
        <More :data="contestResult?.recommends" />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.bread {
  &__bottom {
    &__inner {
      display: flex;
      justify-content: space-between;
      padding-bottom: 35px;
      margin-bottom: 50px;
      border-bottom: 1px solid #000;

      @include max-media(480) {
        padding-bottom: 28px;
        margin-bottom: 40px;
      }
    }
  }
}

.content {
  &__inner {
    padding-left: 135px;
    padding-right: 135px;

    @include max-media(1024) {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
